import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '../src/assets/input-css/input.css'
import 'boxicons/css/boxicons.min.css'
import 'tw-elements';
import 'animate.css';
import 'swiper';
import VueRecaptcha from "vue3-recaptcha-v2";

router.beforeEach((to, from, next) => {

    window.scrollTo(0, 0);
    next();
    
    const isPaymentProcess = parseInt(localStorage.getItem("isPaymentProcess"));

    if (to.meta.isPaymentRoute && isPaymentProcess !== 1) next({ name: 'OCTOVERSE' })
    else next()
})

const app = createApp(App);

app
  .use(VueRecaptcha, {
    siteKey: "6LfbhYYkAAAAADnL2cR8_EA2EMFrm8Rae6rG-4I4",
    alterDomain: false, // default: false
  })
  .use(store)
  .use(router)
  .mount("#app");

// createApp(App).use(store).use(router).mount('#app')
